/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum VehicleMovementType {
    START = 'start',
    STOP = 'stop',
    CONTINUE = 'continue'
}


export function instanceOfVehicleMovementType(value: any): boolean {
    for (const key in VehicleMovementType) {
        if (Object.prototype.hasOwnProperty.call(VehicleMovementType, key)) {
            if (VehicleMovementType[key as keyof typeof VehicleMovementType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VehicleMovementTypeFromJSON(json: any): VehicleMovementType {
    return VehicleMovementTypeFromJSONTyped(json, false);
}

export function VehicleMovementTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleMovementType {
    return json as VehicleMovementType;
}

export function VehicleMovementTypeToJSON(value?: VehicleMovementType | null): any {
    return value as any;
}

export function VehicleMovementTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): VehicleMovementType {
    return value as VehicleMovementType;
}

